import config        from "../config"
import ProductModel  from "shop/ProductModel"
import SessionModel  from "shop/SessionModel"
import DownloadStore from "shop/DownloadStore"

import OrderlistStore   from "sdk/store/OrderlistStore"
import OrderlistStoreV2 from "sdk/store/OrderlistStoreV2"
import AddressStore     from "sdk/store/AddressStore"
import ServerStore      from "sdk/store/ServerStore"
import OrderlistServiceV2 from "sdk/OrderlistServiceV2"

// new land (direct importing creates compile time errors)
import categoryStore from "stores/categoryStore"
import languageStore from "stores/languageStore"

import Api from "sdk/Api.js"

const shop = new Api( config )

// Edit below this line

shop.ProductModel = ProductModel
shop.SessionModel = SessionModel
shop.name = "BASE"
shop.store = {}
shop.store.categories = categoryStore
shop.store.language = languageStore
shop.store.downloads = new DownloadStore( shop )
shop.store.addresses = new AddressStore( shop )
shop.store.orderlist   = new OrderlistStore( shop )
shop.store.orderlistV2 = new OrderlistStoreV2( shop )
shop.store.server      = new ServerStore( shop )
shop.orderlistV2       = new OrderlistServiceV2( { shop } )
shop.seoDefault = {
  title: process.env.REACT_APP_SHOP_TITLE || "B2B Shop",
  description: "B2B Online-Shop"
}

console.log( "SHOP CREATED", shop.name )

window.shop = shop // DEBUG
export default shop



// WEBPACK FOOTER //
// ./src/theme/base/shop/shop.js